export enum Communicator {
  IP = 'ip',
  LORA = 'lora',
  IOT = 'iot',
  CRESTRON = 'crestron',
  Q_SYS = 'q-sys',
}
